import React from 'react';

import { i18n } from '../../../../../../shared/helpers/i18n';
import { ToolbarOption } from '../../toolbar-option';

export function WaitingCloudRecordingOption() {
    const title = i18n('toolbar', 'cloud-recording-prepare');

    return <ToolbarOption iconName="record" title={title} content={title} disabled />;
}
